<template>
  <div class="quantity-selector" :class="{ 'disabled': disabled }">
    <!-- Decrease Button -->
    <button 
      type="button"
      class="qty-btn qty-minus"
      :disabled="quantity <= minQuantity || disabled"
      @click="decreaseQuantity"
      aria-label="Decrease quantity"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="17.6" height="17.6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    </button>

    <!-- Quantity Display / Input -->
    <div class="qty-display">
      <span class="qty-number">{{ quantity }}</span>
      <span class="qty-label">{{ quantity === 1 ? 'buc' : 'buc' }}</span>
    </div>

    <!-- Increase Button -->
    <button 
      type="button"
      class="qty-btn qty-plus"
      :disabled="quantity >= maxQuantity || disabled"
      @click="increaseQuantity"
      aria-label="Increase quantity"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="17.6" height="17.6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuantitySelector',
  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      quantity: this.value
    }
  },
  computed: {
    minQuantity() {
      return Math.max(1, this.min);
    },
    maxQuantity() {
      return this.max > 0 ? this.max : 99;
    }
  },
  watch: {
    value(newVal) {
      this.quantity = newVal;
    },
    quantity(newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    }
  },
  methods: {
    increaseQuantity() {
      if (this.quantity < this.maxQuantity && !this.disabled) {
        this.quantity++;
      }
    },
    decreaseQuantity() {
      if (this.quantity > this.minQuantity && !this.disabled) {
        this.quantity--;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.quantity-selector {
  display: inline-flex;
  align-items: center;
  background: #fff;
  border: 2.2px solid #e0e0e0;
  border-radius: 13.2px;
  overflow: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 2.2px 8.8px rgba(0, 0, 0, 0.04);

  &:hover:not(.disabled) {
    border-color: #c0c0c0;
    box-shadow: 0 4.4px 13.2px rgba(0, 0, 0, 0.08);
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.qty-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 39.6px;
  height: 39.6px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
  outline: none;

  &:hover:not(:disabled) {
    background: #f5f5f5;
    color: #333;
  }

  &:active:not(:disabled) {
    background: #e8e8e8;
    transform: scale(0.95);
  }

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }

  svg {
    pointer-events: none;
  }
}

.qty-minus {
  border-right: 1.1px solid #e0e0e0;
}

.qty-plus {
  border-left: 1.1px solid #e0e0e0;
}

.qty-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 55px;
  padding: 0 8.8px;
  user-select: none;
}

.qty-number {
  font-size: 1.21rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.qty-label {
  font-size: 0.77rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.55px;
}

/* Mobile optimizations */
@media screen and (max-width: 420px) {
  .quantity-selector {
    border-radius: 11px;
  }

  .qty-btn {
    width: 35.2px;
    height: 35.2px;
  }

  .qty-display {
    min-width: 46.2px;
  }

  .qty-number {
    font-size: 1.1rem;
  }
}
</style>